import Swal from "sweetalert2";

class SwalAlert {
  success(text) {
    Swal.fire({
      icon: "success",
      text: text || "alert.",
      confirmButtonColor: "#1E8449",
    });
  }

  error(text) {
    Swal.fire({
      icon: "error",
      text: text || "alert.",
      confirmButtonColor: "#B03A2E",
    });
  }

  warning(text) {
    Swal.fire({
      icon: "warning",
      text: text || "alert.",
      confirmButtonColor: "#D4AC0D",
    });
  }

  closeSession(text, navigate) {
    Swal.fire({
      icon: "error",
      text: text || "alert.",
      confirmButtonColor: "#B03A2E",
    }).then((result) => {
      localStorage.clear();
      navigate("/");
    });
  }
}

export default SwalAlert;
